import { IRecentTest } from './../../../_interfaces/patients/i-recent-test';
import { IPreviousTest } from './../../../_interfaces/patients/i-previous-test';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { showNotification } from 'src/app/helpers/show-toast';
import { MedicalTestRequestService } from 'src/app/_services/medical-test-request/medical-test-request.service';
import { ChannelTypeEnum } from 'src/app/enums/channel-type.enum';
import { FilterParams } from 'src/app/_models/patient.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { IPatientMedicalTest } from 'src/app/_interfaces/patients/i-patient-medical-tests';
import { DatePipe } from '@angular/common';
import { GetChannelNamePipe } from 'src/app/pipe/get-channel-name.pipe';
import { UploadMultipleFilesWithContentModalComponent } from '@components/upload-multiple-files-with-content-modal/upload-multiple-files-with-content-modal.component';
import { EhrTypeEnum } from 'src/app/enums/ehr-type.enum';
import { IFile } from 'src/app/_interfaces/files/i-files';
import { EhrTestResultsFilesServiceService } from 'src/app/_services/patient-emr/ehr-test-results-files-service.service';

@Component({
  selector: 'app-medical-tests',
  templateUrl: './medical-tests.component.html',
  styleUrls: ['./medical-tests.component.scss'],
})
export class MedicalTestsComponent implements OnInit {
  patientId: string;
  recentTestRequests: IRecentTest[] = [];
  previousTestRequests: IPreviousTest[] = [];

  recentMedicalTests: IPatientMedicalTest[] = [];
  completedMedicalTests: IPatientMedicalTest[] = [];
  modifiedRecentMedicalTests: any[] = [];
  modifiedCompletedMedicalTests: any[] = [];

  recentTestsThead: string[];
  previousRequestsThead: string[];
  searchParams: FilterParams = {
    currentPage: 1,
    pageSize: 10,
  };
  loading = false;
  totalPages: number;
  modalRef: BsModalRef;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private medicalTestRequestService: MedicalTestRequestService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private datePipe: DatePipe,
    private channelPipe: GetChannelNamePipe,
    private modalService: BsModalService,
    private ehrTestResultsFilesServiceService: EhrTestResultsFilesServiceService,
  ) { }

  ngOnInit(): void {
    this.patientId = this.activatedRoute.snapshot.params.patientId;

    // this.getPatientTestRequests(this.patientId);
    this.getPatientRecentMedicalTests(this.patientId, this.searchParams.currentPage, this.searchParams.pageSize);
    this.getPatientCompletedMedicalTests(this.patientId, this.searchParams.currentPage, this.searchParams.pageSize);
  }

  onScrollDown(isRecent: boolean) {
    if (this.searchParams.currentPage < this.totalPages) {
      this.searchParams.currentPage++;
      if (isRecent)
        this.getPatientRecentMedicalTests(this.patientId, this.searchParams.currentPage, this.searchParams.pageSize, true);
      else
        this.getPatientCompletedMedicalTests(this.patientId, this.searchParams.currentPage, this.searchParams.pageSize, true);
    }
  }

  getPatientRecentMedicalTests(patientId: string, currentPage: number, pageSize: number, scroll = false) {
    this.loading = true;
    this.spinner.show();
    this.medicalTestRequestService.getPatientRecentMedicalTests(patientId, currentPage, pageSize)
      .subscribe(res => {
        this.recentMedicalTests = scroll ? [...this.recentMedicalTests.concat(res.data.items)] : res.data.items;
        this.loading = false;
        this.modifiedRecentMedicalTests = this.modifyRecentMedicalTestsMapper(this.recentMedicalTests);
        this.totalPages = res.data.pagination.totalPages;
        this.searchParams.currentPage = res.data.pagination.currentPage;
        this.spinner.hide();
      });
  }

  getPatientCompletedMedicalTests(patientId: string, currentPage: number, pageSize: number, scroll = false) {
    this.loading = true;
    this.spinner.show();
    this.medicalTestRequestService.getPatientCompletedMedicalTests(patientId, currentPage, pageSize)
      .subscribe(res => {
        this.completedMedicalTests = scroll ? [...this.completedMedicalTests.concat(res.data.items)] : res.data.items;
        this.loading = false;
        this.modifiedCompletedMedicalTests = this.modifyCompletedMedicalTestsMapper(this.completedMedicalTests);
        this.totalPages = res.data.pagination.totalPages;
        this.searchParams.currentPage = res.data.pagination.currentPage;
        this.spinner.hide();
      });
  }

  modifyRecentMedicalTestsMapper(medicalTests: IPatientMedicalTest[]) {
    this.recentTestsThead = ['Request Date', 'Channel', 'No. of Tests', 'Tests Name', 'Physiotherapy', 'Request Status'];

    return medicalTests.map(m => {
      return {
        id: m.id,
        channel: this.channelPipe.transform(m.channelId),
        nooftests: m.testCount,
        testsname: m.testNames,
        physiotherapy: m.physiotherapyNames,
        requestdate: this.datePipe.transform(m.testDate, "MMM d, y, h:mm a"),
        requeststatus: 'Pending',
        sourcetype: m.sourceType
      }
    });
  }

  modifyCompletedMedicalTestsMapper(medicalTests: IPatientMedicalTest[]) {
    this.previousRequestsThead = ['Request Date', 'Channel', 'No. of Tests', 'No. of Files', 'Tests Name', 'Physiotherapy'];
    return medicalTests.map(m => {
      return {
        id: m.id,
        channel: this.channelPipe.transform(m.channelId),
        nooftests: m.testCount,
        nooffiles: m.attachmentUrls.length,
        testsname: m.testNames,
        physiotherapy: m.physiotherapyNames,
        requestdate: this.datePipe.transform(m.testDate, "MMM d, y, h:mm a"),
        attachmentUrls: m.attachmentUrls,
        typeids: m.typeIds,
        iseditable: m.isEditable,
        testdate: m.testDate,
        upload: !m.typeIds.includes(EhrTypeEnum.TestRequestTypeId) &&
          !m.typeIds.includes(EhrTypeEnum.UploadedPrescriptionTypeId),
        download: true,
        sourcetype: m.sourceType
      }
    });
  }

  onMedicalTestClick(medicalTest) {
    // let medicalTestId = medicalTest.id;
    // let sourceType = medicalTest.sourcetype;.
    this.router.navigate(['test-request-details'], {
      queryParams: { medicalTestId: medicalTest.id, sourceType: medicalTest.sourcetype },
    });
  }

  // getPatientTestRequests(patientId) {
  //   this.medicalTestRequestService
  //     .getPatientTestRequests(patientId)
  //     .subscribe((response) => {
  //       this.recentTestRequests = response.data.recentTestRequests;
  //       this.previousTestRequests = response.data.previousTestRequests;
  //     });
  // }

  getChannelType(channelId) {
    if (channelId == ChannelTypeEnum.application) return 'Application';
    else if (channelId == ChannelTypeEnum.admin) return 'Admin';
    else if (channelId == ChannelTypeEnum.portal) return 'Portal';
    return '--';
  }

  downloadFile(fileUrl) {
    this.medicalTestRequestService
      .downloadFile(fileUrl)
      .subscribe((response) => {
        let fileName = fileUrl.split('/').pop();
        let a = document.createElement('a');
        let objectUrl = URL.createObjectURL(response);
        a.href = objectUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(objectUrl);
      });
  }

  downloadTestRequestResults(event) {
    event.event.stopPropagation();
    let testResults = event.rowData.attachmentUrls;

    if (testResults?.length) {
      testResults.forEach((resultUrl) => {
        this.downloadFile(resultUrl.path);
      });
    } else {
      showNotification(
        'danger',
        'There is no results to download!',
        this.toastr
      );
    }
  }

  // onTestRequestClick(id, emrDiscriminator) {
  //   this.router.navigate(['test-request-details'], {
  //     queryParams: { id, emrDiscriminator },
  //   });
  // }

  // onAddNewTest(event) {
  //   event.stopPropagation();

  //   this.router.navigate(['patient-details', this.patientId, 'add-new-test']);
  // }

  viewMedicalTestFiles(event) {

    event.event.stopPropagation();
    let isTestRequest = event.rowData.typeids.includes(EhrTypeEnum.TestRequestTypeId);
    let files: IFile[] = event.rowData.attachmentUrls.map(a => {
      return {
        id: a.id,
        path: a.path,
        isEditable: event.rowData.iseditable,
      }
    })

    const initialState: ModalOptions<any> = {
      keyboard: true,
      class: 'modal-dialog-centered',
      initialState: {
        title: 'Upload Files',
        subtitle: isTestRequest ? 'Please upload tests results below by dragging the file or clicking upload files' : 'Please add date for this file then upload files',
        filesExisted: files,
        isUploadable: event.rowData.iseditable,
        isHaveContent: !isTestRequest,
        testDate: this.datePipe.transform(event.rowData.testdate, "yyyy-MM-dd"),
        isUpdate: true
      }
    };

    this.modalRef = this.modalService.show(
      UploadMultipleFilesWithContentModalComponent,
      initialState
    );

    this.modalRef.content.event.subscribe((response) => {
      if (response.action === 'deleteFile') {
        this.deleteTestResultFilesAddedByAdmin(event.rowData.id, response.file.id);
      }

      if (response.action === 'uploadFiles') {
        this.updateEhrTestResultsFilesByAdmin(event.rowData.id, response.testDate, response.filesToUpload, event.rowData.testdate);
      }
    });
  }

  onUploadTestResult(event) {
    const initialState: ModalOptions<any> = {
      keyboard: true,
      class: 'modal-dialog-centered',
      initialState: {
        // test: test,
        // testRequestId: this.testRequestId,
        // emrDiscriminator: this.emrDiscriminator,
      },
    };
  }

  deleteTestResultFilesAddedByAdmin(ehrTransactionId, fileId) {
    this.ehrTestResultsFilesServiceService.deleteTestResultFilesAddedByAdmin(ehrTransactionId, fileId)
      .subscribe((res) => {
        if (res.data.flag) {
          let modifiedMedicalTestAttachments = this.modifiedCompletedMedicalTests.find(t => t.id == ehrTransactionId).attachmentUrls;
          this.modifiedCompletedMedicalTests.find(t => t.id == ehrTransactionId).attachmentUrls = modifiedMedicalTestAttachments.filter(t => t.id != fileId);
          showNotification('success', 'file is deleted successfully', this.toastr);
        }
        else {
          showNotification('danger', res.errorList[0].message, this.toastr);
        }
      });
  }

  updateEhrTestResultsFilesByAdmin(ehrTransactionId, testDate, files, ehrTransactionTestDate) {
    if (!files.length
      && (this.datePipe.transform(testDate, 'yyyy-MM-dd') == this.datePipe.transform(ehrTransactionTestDate, 'yyyy-MM-dd')))
      return;
    this.ehrTestResultsFilesServiceService.updateEhrTestResultsFilesByAdmin(ehrTransactionId,
      testDate, files)
      .subscribe((res) => {
        if (res.data) {
          this.modifiedCompletedMedicalTests.find(t => t.id == ehrTransactionId).attachmentUrls = res.data.attachmentUrls;
          showNotification('success', 'Test result is updated successfully', this.toastr);
        }
        else {
          showNotification('danger', res.errorList[0].message, this.toastr);
        }
        this.modalRef.hide();
      });
  }
}
